<svg xmlns="http://www.w3.org/2000/svg" width="8" height="4" viewBox="0 0 8 4">
  <path d="M0,0l4,4,4-4" fill="#1c88c8" />
</svg>
